<template>
  <v-app>
    <!--<v-navigation-drawer v-model="drawer" right app>
    </v-navigation-drawer>-->
    <v-app-bar elevation="10" elevate-on-scroll height="100" flat color="#A90003" app style="z-index:3">
      <v-toolbar-title class="mr-sm-8 mt-5">
        <v-img class="mt-16 mr-lg-16" width="300" src="/test.png" />
      </v-toolbar-title>
      <div class="d-none d-lg-block" style="height: 51px;margin-top: 49px;margin-left: -18px;">
        <div id="curved-corner-bottomleft" style="margin-top: 5px;height: 46px;"></div>
      </div>
      <v-col class="d-none d-lg-block"
        style="margin-top: 51px;background-color:black;border-radius: 21% 10% 0% 0% / 0% 209% 0% 0%;margin-left:-69px;position: relative;">
        <v-col class="d-flex pa-0">
          <h4 @click="$router.push({name:'Home'})" class="text-white mr-10 f_size" style="color:white;cursor:pointer">
            خانه</h4>
          <h4 @click="$router.push({name:'Products'})" class="text-white mr-10 f_size"
            style="color:white;cursor:pointer">محصولات</h4>
          <h4 class="text-white mr-10 f_size" style="color:white;cursor:pointer">آشپزی با پونه</h4>
          <h4 @click="$router.push({name:'Blog'})" class="text-white mr-10 f_size" style="color:white;cursor:pointer">
            وبلاگ</h4>
          <h4 @click="$router.push({name:'About'})" class="text-white mr-10 f_size" style="color:white;cursor:pointer">
            درباره ما</h4>
          <h4 @click="$router.push({name:'Honors'})" class="text-white mr-10 f_size" style="color:white;cursor:pointer">
             افتخارات</h4>
          <h4 class="text-white mr-10 f_size" style="color:white;cursor:pointer">ورود به پنل مشتریان</h4>
        </v-col>
      </v-col>
      <div class="d-none d-md-flex d-lg-none" style="height: 51px;margin-top: 49px;margin-left: -18px;">
        <div id="curved-corner-bottomleft" style="margin-top: 5px;height: 46px;"></div>
      </div>


      <v-col class="d-md-none" @click="clicked"
        style="margin-top: 52px;background-color:black;border-radius: 20px 30px 0% 0%;margin-left:-69px;position: relative;">
        <v-btn @click="clicked" icon x-small class="mr-4">
          <iconly name="category" size="22" type="bold" color="white" />
        </v-btn>
      </v-col>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <v-list-item to="/">
            <v-list-item-title>خانه</v-list-item-title>
          </v-list-item>

          <v-list-item to="/products">
            <v-list-item-title>محصولات</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title>آشپزی با پونه</v-list-item-title>
          </v-list-item>

          <v-list-item to="/blog">
            <v-list-item-title>وبلاگ</v-list-item-title>
          </v-list-item>
          <v-list-item to="/about">
            <v-list-item-title>درباره ما</v-list-item-title>
          </v-list-item>
          <v-list-item to="/honors">
            <v-list-item-title>افتخارات</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>ورود به پنل مشتریان</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>

      <v-container fluid>

        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer color="#a90003" width="100%">
      <v-row class="pr-md-16 pl-md-16">
        <v-col cols="12" sm="4">
          <v-row>
            <!-- <v-col class="mt-3" cols="12">
              <v-img class="mx-auto text-center" src="/log.png" width="100"></v-img>
            </v-col> -->
            <v-col class="mt-8 mb-2" cols="12">
              <span class="ml-5 font-l white--text">آدرس :</span> <span class="white--text">کارخانه: کیلومتر 15 جاده
                شیراز سپیدان </span> <br>
              <span class="ml-5 font-l white--text">تلفن :</span> <span class="white--text"
                style="display: inline-block;">07136265268</span><br>
              <!-- <span class="ml-5 font-l">ایمیل :</span> <span>example@mail.com </span> -->
            </v-col>
          </v-row>
        </v-col>
        <v-col class="d-none d-sm-block pr-16" cols="12" sm="4">
         
          <ul class="mt-6" style="list-style: none;">
            <li class="mb-2 white--text"><a class="white--text" href="/" style="text-decoration:none">صفحه اصلی</a></li>
            <li class="mb-2 white--text"><a class="white--text" href="/blog" style="text-decoration:none">وبلاگ</a></li>
            <li class="mb-2 white--text"><a class="white--text" href="/products"
                style="text-decoration:none">محصولات</a></li>
            <li class="mb-2 white--text"><a class="white--text" href="/about" style="text-decoration:none">درباره ما</a>
            </li>
            <li class="mb-2 white--text"><a class="white--text" href="/honors" style="text-decoration:none">افتخارات</a>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" sm="4">
          <v-lazy>
            <v-row class="mt-7">
              <v-col cols="4">
                  <v-img
                    src="/loh.12.jpg"
                    width="100"></v-img>
              </v-col>
              <v-col class="pr-0" cols="4">
                  <v-img
                    src="/loh.14.jpg"
                    width="100"></v-img>
              </v-col>
              <v-col class="pr-0" cols="4">
                  <v-img
                    src="/loh.11.jpg"
                    width="100"></v-img>
              </v-col>
            </v-row>
          </v-lazy>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-5 w-100" style="background-color:#a90003;width:100%">
        <v-col class="pa-0" cols="12" style="height:37px">
          <p class="text-center d-none d-sm-block white--text font-l pt-2">کپی‌رایت © کلیه حقوق این سایت محفوظ و متعلق
            به
            صنایع غذایی پونه است</p>
          <h6 class="text-center white--text d-sm-none font-l pt-2">کپی‌رایت © کلیه حقوق این سایت محفوظ و متعلق به
            صنایع غذایی پونه است</h6>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    name: 'App',


    data: () => ({
      drawer: false,
      selectedItem: 0,
      ShowWhiteNav: false,
      ShowColorNav: true,
    }),
    created() {

    },
    methods: {
      clicked() {
        this.drawer = true
      }
    }
  };
</script>

<style lang="scss">
  #curved-corner-bottomleft,
  #curved-corner-bottomright,
  #curved-corner-topleft,
  #curved-corner-topright {
    width: 100px;
    height: 48px;
    overflow: hidden;
    position: relative;
  }

  #curved-corner-bottomleft:before,
  #curved-corner-bottomright:before,
  #curved-corner-topleft:before,
  #curved-corner-topright:before {
    content: "";
    display: block;
    width: 200%;
    height: 200%;
    position: absolute;
    border-radius: 50% 50% 50% 50%;
  }

  #curved-corner-bottomleft:before {
    bottom: 0;
    left: 0;
    box-shadow: -50px 50px 0 0 black;
  }

  #curved-corner-bottomright:before {
    bottom: 0;
    right: 0;
    box-shadow: 50px 50px 0 0 black;
  }

  #curved-corner-topleft:before {
    top: 0;
    left: 0;
    box-shadow: -50px -50px 0 0 black;
  }

  #curved-corner-topright:before {
    top: 0;
    right: 0;
    box-shadow: 50px -50px 0 0 black;
  }

  .f_size {
    font-size: 14px;
    margin-top: 4px;
  }
</style>
